import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { AppContextProvider } from './context/AppContext';
import { TodosContextProvider } from './context/TodosContext';

ReactDOM.render(
	<AppContextProvider>
		<TodosContextProvider>
			<App />
		</TodosContextProvider>
	</AppContextProvider>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
